import { autobind } from 'core-decorators';
/* eslint-disable max-len */
import { Component } from 'react';

import Popup from '/@/components/popup';
import { _ } from '/@/locale';
import { getBrowser, getBrowserVersion, getOS, getOSVersion } from '/@/utils';
import styles from './styles.module.css';

@autobind
export default class IOSSafariReminder extends Component {
    state = {
        visible: this.shouldShow(),
    };

    shouldShow() {
        return (
            getOS() === 'iOS' &&
            getBrowser().includes('Safari') &&
            Number.parseFloat(getOSVersion()) < 11.3 &&
            Number.parseFloat(getBrowserVersion()) < 11.1 &&
            !localStorage.getItem('cultivio.disableIOSSafariReminder')
        );
    }

    handleClose() {
        localStorage.setItem('cultivio.disableIOSSafariReminder', true);
        this.setState({ visible: false });
    }

    render() {
        return (
            <Popup visible={this.state.visible} onClose={this.handleClose}>
                <div className={styles.root}>
                    {_(
                        'Por favor, actualizá tu versión de Safari para contar con acceso al modo offline. De otro modo, la app va a funcionar solamente cuando estés online.'
                    )}
                </div>
            </Popup>
        );
    }
}
